export default __webpack_public_path__ + "5852fb23ce899686ce1f8e1fd2177ef3.png";